export default __webpack_public_path__ + "static/media/campminderAdminLogin.682596d6.png";